/**
 * Job conversations & messaging API. Phase 26b.
 */

import client from './client';

// ── Conversations ────────────────────────────────────────────────────

export async function fetchConversations(jobId) {
  const { data } = await client.get(`/jobs/${jobId}/conversations/`);
  return data.data || [];
}

export async function createConversation(jobId, payload) {
  // payload: { participant_ids: [...], title?, initial_message?, message_type? }
  const { data } = await client.post(`/jobs/${jobId}/conversations/`, payload);
  return data.data;
}

// ── Messages ─────────────────────────────────────────────────────────

export async function fetchMessages(jobId, conversationId) {
  const { data } = await client.get(`/jobs/${jobId}/conversations/${conversationId}/messages/`);
  return data.data || [];
}

export async function sendMessage(jobId, conversationId, payload) {
  // payload: { body, message_type?, reply_to?, mentioned_users? }
  const { data } = await client.post(`/jobs/${jobId}/conversations/${conversationId}/messages/`, payload);
  return data.data;
}

// ── Global unread ────────────────────────────────────────────────────

export async function getUnreadMessages() {
  const { data } = await client.get('/jobs/unread-messages/');
  return data.data || { total_unread: 0, jobs: [] };
}
